
import ValidationResponse from "@/components/base/api/ValidationResponse"
import CodeInput from "@/components/base/input/CodeInput"
import Button from "@/components/base/Button"
import ProgressLinear from "@/components/base/ProgressLinear"
import authService from "@/services/auth.service"
export default {
    name: "AccountVerification",
    components: { CodeInput, ValidationResponse, Button, ProgressLinear },
    props: {
        email: String,
        password: String,
        length: {
            type: Number,
            default: 4,
        },
        polite: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        validationData: null,
        isValidating: false,
    }),
    computed: {
        headline() {
            const du =
                "Wir haben Dir gerade eine E-Mail mit dem Bestätigungscode geschickt. Bitte trage den Code ein, um fortzufahren."
            const sie =
                "Wir haben Ihnen gerade eine E-Mail mit dem Bestätigungscode geschickt. Bitte tragen Sie den Code ein, um fortzufahren."
            return this.polite ? sie : du
        },
        hint() {
            const du =
                "Sieh in Deinem Ordner „Werbung“ nach oder warte einige Minuten. Solltest Du weiterhin Probleme haben, kannst Du einen neuen Code anfordern."
            const sie =
                "Sehen Sie in Ihrem Ordner „Werbung“ nach oder warten Sie einige Minuten. Sollten Sie weiterhin Probleme haben, können Sie einen neuen Code anfordern."
            return this.polite ? sie : du
        },
    },
    methods: {
        requestNewCode() {
            authService
                .requestEmailCode(this.email, this.password)
                .then((response) => {
                    this.validationData = response
                })
                .catch((error) => {
                    this.validationData = error.response.data
                })
        },
        async validateCode(code) {
            if (this.isValidating) return
            this.isValidating = true
            await authService
                .verifyEmail(this.email, this.password, code)
                .then(() => {
                    this.$emit("success")
                })
                .catch((error) => {
                    this.validationData = error.response.data
                    console.error(
                        "ERROR @ Register Code Verification ",
                        error.response
                    )
                })
            this.isValidating = false
        },
    },
}
